import { SET_BOTTOM_PADDING } from './mutations';

export const actions = {
    setBottomPadding({ commit }, payload) {
        commit(SET_BOTTOM_PADDING, payload);
    },
};
